<template>
  <ul :class="style[wrapClass]">
    <li
      v-for="(item, index) in displayList"
      :key="index"
      v-theme-bg-hover
      :class="style['option']"
      @click="clickOptions(item)"
    >
      <div :class="style.img" :style="imgBackground(item.img)" />
      <div :class="style['info-block']">
        <h3 :class="style['name']">{{ item.name }}</h3>
        <span v-if="!!item.unread_messages" :class="style['unread-messages']">{{
          item.unread_messages
        }}</span>
        <br />
        <p :class="style['description']">{{ item.address }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
import style from './scss/_imglist.scss'

export default {
  props: {
    displayList: { type: Array, default: () => [] },
    wrapClass: { type: String, default: 'img-group' }
  },

  data: () => ({ style }),

  methods: {
    clickOptions(item) {
      this.$emit('click', item)
    },
    imgBackground(img) {
      return {
        background: `url(${img}) no-repeat center`,
        backgroundSize: 'cover'
      }
    }
  }
}
</script>
